import { render, staticRenderFns } from "./AnnouncementAdd.vue?vue&type=template&id=ccc29512"
import script from "./AnnouncementAdd.vue?vue&type=script&lang=js"
export * from "./AnnouncementAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports